import * as Yup from "yup";

export const PersonalDetailsFormSchema = Yup.object().shape({
  fullName: Yup.string()
    .required("This field is required")
    .matches(/^[\w\-\s]+$/, "Invalid input"),
  email: Yup.string()
    .email("Must be a valid email")
    .required("This field is required"),
});
